"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionDeriveRequestToJSON = exports.RosettaConstructionDeriveRequestFromJSONTyped = exports.RosettaConstructionDeriveRequestFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaConstructionDeriveRequestFromJSON(json) {
    return RosettaConstructionDeriveRequestFromJSONTyped(json, false);
}
exports.RosettaConstructionDeriveRequestFromJSON = RosettaConstructionDeriveRequestFromJSON;
function RosettaConstructionDeriveRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'public_key': _1.RosettaPublicKeyFromJSON(json['public_key']),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaConstructionDeriveRequestFromJSONTyped = RosettaConstructionDeriveRequestFromJSONTyped;
function RosettaConstructionDeriveRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'public_key': _1.RosettaPublicKeyToJSON(value.public_key),
        'metadata': value.metadata,
    };
}
exports.RosettaConstructionDeriveRequestToJSON = RosettaConstructionDeriveRequestToJSON;
//# sourceMappingURL=RosettaConstructionDeriveRequest.js.map